import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {isSecurityKeysEqual, SecurityKey} from '../../../models/security-key';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {ChartWidget} from '../chart-widget';
import {ChartWidgetSettings} from './chart-widget-settings';

interface SettingsFormValue {
    title: string;
    security: SecurityKey;
    isConfirmationEnabled: boolean;
}

@Component({
    selector: 'chart-widget-settings',
    templateUrl: './chart-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChartWidgetSettingsComponent extends WidgetImplSettingsComponentBase<ChartWidget> {

    @Input()
    public override widget: ChartWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: ChartWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:                 this.createTitleFormControl(settings),
            security:              this.createSecurityFormControl(settings),
            isConfirmationEnabled: this.createIsConfirmationEnabledControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

    private createSecurityFormControl(settings: ChartWidgetSettings): FormControl {
        const control: FormControl = new FormControl(settings.securityKey);

        this.bindControlToSettings({
            control,
            settingsFieldName: 'securityKey',
            controlValueEqualityPredicate: isSecurityKeysEqual
        });

        return control;
    }

    private createIsConfirmationEnabledControl(settings: ChartWidgetSettings): FormControl {
        const control: FormControl = new FormControl(settings.isConfirmationEnabled);

        this.bindControlToSettings({control, settingsFieldName: 'isConfirmationEnabled'});

        return control;
    }

}
